// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("../assets/img/angle-left.svg");
exports = ___CSS_LOADER_API_IMPORT___(false);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
exports.push([module.id, ".btn-back[data-v-6e26a946]{width:8px;height:20px;margin-right:16px;background:#fff url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ") no-repeat 50%}button[data-v-6e26a946]{cursor:pointer}", ""]);
// Exports
module.exports = exports;
